import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SplashScreen from './pages/SplashScreen';
import Auth from './pages/Auth';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MagicLogin from './pages/MagicLogin';
import Dashboard from './pages/Dashboard';
import NovoLembrete from './pages/NovoLembrete';
import Timeline from './pages/Timeline';
import Importacoes from './pages/Importacoes';
import EmpresaPublica from './pages/EmpresaPublica';
import MeuQRCode from './pages/MeuQRCode';
import Perfil from './pages/Perfil';
import FAQ from './pages/FAQ';
import Sobre from './pages/Sobre';
import Planos from './pages/Planos';
import ComoFunciona from './pages/ComoFunciona';
import CadastroSucesso from './pages/CadastroSucesso';
import TermosUso from './pages/TermosUso';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import AdminLogin from './pages/AdminLogin';
import AdminBackoffice from './pages/AdminBackoffice';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/sonner';

// Proteção de rotas para usuários logados
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('lembrou_token');
  if (!token) {
    return <Navigate to="/auth" replace />;
  }
  return children;
};

// Proteção de rotas para admin
const AdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/admin-lembrou" replace />;
  }
  // Verificar se token não expirou (básico)
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem('admin_token');
      return <Navigate to="/admin-lembrou" replace />;
    }
  } catch (e) {
    localStorage.removeItem('admin_token');
    return <Navigate to="/admin-lembrou" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<SplashScreen />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/cadastro-sucesso" element={<CadastroSucesso />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/magic-login" element={<MagicLogin />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/planos" element={<Planos />} />
          <Route path="/como-funciona" element={<ComoFunciona />} />
          <Route path="/termos" element={<TermosUso />} />
          <Route path="/privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/admin-lembrou" element={<AdminLogin />} />
          <Route 
            path="/admin-lembrou/backoffice" 
            element={
              <AdminProtectedRoute>
                <AdminBackoffice />
              </AdminProtectedRoute>
            } 
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meu-qrcode"
            element={
              <ProtectedRoute>
                <MeuQRCode />
              </ProtectedRoute>
            }
          />
          <Route
            path="/perfil"
            element={
              <ProtectedRoute>
                <Perfil />
              </ProtectedRoute>
            }
          />
          <Route
            path="/importacoes"
            element={
              <ProtectedRoute>
                <Importacoes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lembretes/novo"
            element={
              <ProtectedRoute>
                <NovoLembrete />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lembretes/editar/:id"
            element={
              <ProtectedRoute>
                <NovoLembrete />
              </ProtectedRoute>
            }
          />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/q/:qrId" element={<Timeline />} />
          <Route path="/empresa/:empresaId" element={<EmpresaPublica />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;